module.exports = __webpack_public_path__ + "static/img/paiwei-img.316a153.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/paiwei-img.png
// module id = mldL
// module chunks = 1